import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-footer';

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="layout-footer">
    <div class="main-footer">
      <div class="col-item company-info">
        <div class="wrap-logo-footer">
          <img
            data-attribute="logo-footer"
            src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fc9c77277577a9729ccb.png"
            alt=""
          />
        </div>
        <div data-attribute="address-store" class="address-store">
          Address: 524 Federal Avenue East Seattle, WA 98102 US
        </div>
        <div data-attribute="list-item-company-info" class="list-item">
          <a href="mailto:support@calyrafit.com" data-attribute="item-company-info" class="item-child"
            >📩 support@calyrafit.com</a
          >
        </div>
        <div data-attribute="list-item-social" class="list-item-social">
          <a href="" data-attribute="item-social" class="item-social"
            ><img
              data-attribute="icon-social"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fca0c2753688cac25402.png"
          /></a>
          <a href="" data-attribute="item-social" class="item-social"
            ><img
              data-attribute="icon-social"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fca6086802938922a00b.png"
          /></a>
        </div>
      </div>
      <div class="col-item order-info">
        <div data-attribute="title-column-order" class="title-column">Order</div>
        <div data-attribute="list-item-order" class="list-item">
          <a href="" data-attribute="item-order" class="item-child">24/7 Live Chat Support</a>
          <a href="" data-attribute="item-order" class="item-child">Track My Order</a>
          <a href="" data-attribute="item-order" class="item-child">Contact Us</a>
          <a href="" data-attribute="item-order" class="item-child">Order & Shipping</a>
          <a href="" data-attribute="item-order" class="item-child">Returns & Exchanges</a>
        </div>
      </div>
      <div class="col-item resources-info">
        <div data-attribute="title-column-resources" class="title-column">Resources</div>
        <div data-attribute="list-item-resources" class="list-item">
          <a href="" data-attribute="item-resources" class="item-child">About Us</a>
          <a href="" data-attribute="item-resources" class="item-child">FAQs</a>
          <a href="" data-attribute="item-resources" class="item-child">Terms Of Services</a>
          <a href="" data-attribute="item-resources" class="item-child">Privacy Policy</a>
        </div>
      </div>
      <div class="col-item subscribe-info">
        <div data-attribute="title-column-subscribe" class="title-column">Stay In The Know</div>
        <form class="wrap-input-email">
          <input
            type="email"
            placeholder="Enter Your Email..."
            data-attribute="input-email"
            data-color-input="#AD4870"
            style="--color-input: #AD4870;"
          />
          <button type="submit" data-attribute="btn-submit-email">
            <img
              data-attribute="icon-submit-email"
              src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fc999ca0729b96ea25a6.png"
              alt=""
            />
          </button>
        </form>
        <div data-attribute="description-subscribe" class="description-subscribe">
          Sign up to receive special offers, free gifts and once-in-a-lifetime deals.
        </div>
      </div>
    </div>
    <div class="wrap-payment-icon">
      <img
        data-attribute="payment-icon"
        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fc95bdcd288b3b6c8859.png"
        alt=""
      />
    </div>
  </div>
</div>
<div
  class="bottom-footer"
  data-attribute="bottom-footer"
  data-bg-bottom-footer="#AD4870"
  data-color-bottom-footer="#ffffff"
  style="--bg-bottom-footer: #AD4870; --color-bottom-footer: #ffffff"
>
  <div data-attribute="copyright">© 2026, CALYRAFIT™ All Rights Reserved.</div>
</div>
`;

export default containerFuild(html, css, {
  backgroundImage: 'https://cdn.skyfastimg.com/6a827967ed5928000992f68c/2026/08/20/image-6a866db3526709cd71ca179f.webp',
  textColor: '#ffffff',
  topPadding: false,
  bottomPadding: false,
});
